// extracted by mini-css-extract-plugin
export default {"form":"CompanySetupModal_form__g5lQ+","input":"CompanySetupModal_input__xIN+e"};